<template>
  <v-container>

    <div class="d-flex justify-space-between">
      <div></div>
      <bread-crumbs :items="breadItems"></bread-crumbs>
    </div> 

    <!-- {{ permitObj }} -->
    
    <v-card>
      <v-data-table :items="sessions" :headers="headers">
        <template v-slot:item.group="{ item }">
          <div v-if="item.group != null && typeof item.group != 'undefined'">
            <div v-for="group_student in item.group.group_student">
              <p
                v-if="
                  group_student.student != null &&
                  typeof group_student.student != 'undefined'
                "
              >
                {{ group_student.student.std_fname }}
                {{ group_student.student.std_lname }}
              </p>
            </div>
          </div>
        </template>
        <template v-slot:[`item.session_date`]="{ item }">
          <span>{{ formatDate(item.session_date) }}</span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>

import BreadCrumbs from "../../../components/BreadCrumbs";
import TutorTable from "../../../components/tutors/TutorTable.vue";
import moment from "moment";
import { getPermitObjects } from "../../../utils/allowedPermissions";

export default {
  name: "Tutors",
  components: { TutorTable, BreadCrumbs },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      permitObj:{},
      headers: [
        { text: "Session ID", sortable: true, value: "group_session_id" },
        { text: "Session Name", sortable: true, value: "group.group_name" },
        { text: "Tutor", sortable: true, value: "group.tutor.tutor_fname" },
        { text: "Students", sortable: true, value: "group" },
        { text: "Class", value: "group.class.class_name", sortable: true },
        { text: "Subject", value: "group.subject.subject_name", sortable: false },
        { text: "Date", value: "session_date", sortable: false },
        { text: "Start Time", value: "session_start_time", sortable: false },
        { text: "End Time", value: "session_end_time", sortable: true },
        { text: "Action", value: "action", sortable: true, align: "center" },
      ],
      sessions: [],
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard",
          },
        },
        {
          text: "Session",
          disabled: true,
          to: {
            name: "Session",
          },
        },
      ],
    };
  },
  methods: {
    formatDate(date) {
      if (date !== null) return moment(date).format("DD-MM-YYYY");
    },
    getSessions() {
      axios
        .get("tutor/sessions/" + this.id)
        .then((response) => {
          //   this.getItems();
          console.log(response);
          this.sessions = response.data;
          //   this.deleteConfirmLoading = false;
          //   this.delete_dialog = false;
        })
        .catch((error) => {});
    },
    getPermittedArray() {
      console.log(this.$store, 'this.$store from TutorSessions');
      let links = this.$store?.getters?.permissions;
      let pathName = "TutorSessions";
      this.permitObj = getPermitObjects(links, pathName)
    }
  },
  mounted() {
    this.getSessions();
    this.getPermittedArray();
  },
};
</script>

<style scoped></style>
